import type * as Types from 'app/types/graphql';

export type VariantSelectFragment = Pick<
  Types.Variant,
  | 'id'
  | 'isOrigin'
  | 'isWinner'
  | 'trafficRate'
  | 'themePageID'
  | 'templateType'
  | 'templateSuffix'
  | 'createdAt'
  | 'deletedAt'
  | 'updatedAt'
  | 'winnerTemplateSuffix'
>;

export type VariantWithTemplateSelectFragment = Pick<
  Types.Variant,
  | 'id'
  | 'isOrigin'
  | 'isWinner'
  | 'trafficRate'
  | 'themePageID'
  | 'templateType'
  | 'templateSuffix'
  | 'createdAt'
  | 'deletedAt'
  | 'updatedAt'
  | 'winnerTemplateSuffix'
> & {
  template?: Types.Maybe<
    Pick<
      Types.VariantTemplate,
      | 'createdAt'
      | 'deletedAt'
      | 'id'
      | 'redirectURL'
      | 'themeID'
      | 'updatedAt'
      | 'thumbnailURL'
      | 'title'
    >
  >;
  price?: Types.Maybe<
    Pick<
      Types.VariantPrice,
      'id' | 'baseID' | 'handle' | 'status' | 'title' | 'redirectURL' | 'sourceProductBaseID'
    >
  >;
  productVariants?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.VariantProductVariant,
          'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
        >
      >
    >
  >;
  url?: Types.Maybe<
    Pick<Types.VariantUrl, 'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'>
  >;
};

export type VariantCampaignSelectFragment = Pick<
  Types.Variant,
  | 'id'
  | 'isOrigin'
  | 'isWinner'
  | 'trafficRate'
  | 'themePageID'
  | 'templateType'
  | 'templateSuffix'
  | 'createdAt'
  | 'deletedAt'
  | 'updatedAt'
  | 'winnerTemplateSuffix'
> & {
  campaign?: Types.Maybe<
    Pick<
      Types.Campaign,
      | 'id'
      | 'name'
      | 'type'
      | 'status'
      | 'priority'
      | 'storeDomain'
      | 'targetDevices'
      | 'targetChannels'
      | 'targetCountries'
      | 'targetVisitorTypes'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'startedAt'
      | 'deletedAt'
      | 'completedAt'
    > & {
      group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
      versions?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.SplitTestingCampaignVersion,
              'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
            >
          >
        >
      >;
    }
  >;
};

export const VariantSelectFragmentDoc = `
    fragment VariantSelect on Variant {
  id
  isOrigin
  isWinner
  trafficRate
  themePageID
  templateType
  templateSuffix
  createdAt
  deletedAt
  updatedAt
  winnerTemplateSuffix
}
    `;
export const VariantWithTemplateSelectFragmentDoc = `
    fragment VariantWithTemplateSelect on Variant {
  ...VariantSelect
  template {
    ...VariantTemplateSelect
  }
  price {
    ...VariantPriceSelect
  }
  productVariants {
    ...VariantProductVariantSelect
  }
  url {
    ...VariantURLSelect
  }
}
    `;
export const VariantCampaignSelectFragmentDoc = `
    fragment VariantCampaignSelect on Variant {
  ...VariantSelect
  campaign {
    ...CampaignSelect
  }
}
    `;
